export const OPTIONS = [
    {key: '', value: 'Tipo de cliente', seleted: false},
    {key: 'particular', value: 'Particular', seleted: false},
    {key: 'arquitecto', value: 'Arquitecto', seleted: false},
    {key: 'empresa', value: 'Empresa', seleted: false}
]
